module.exports = __webpack_public_path__ + "img/p18.6779868c.png";